<template>
  <table class="table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="min-width">№</th>
        <th scope="col" class="min-width">Group</th>
        <th scope="col" class="min-width">Size</th>
        <th></th> <!-- empty column for alignment -->
      </tr>
    </thead>
    <tr
      v-for="(group, index) in groups"
      :key="group.id"
    >
      <td class="num">
        {{offset + index + 1 | getFormattedNumber}}
      </td>
      <td>
        <contest-group-link :contestGroupId="createContestGroupId(group.id)"/>
      </td>
      <td>
        {{group.size | getFormattedNumber}}
      </td>
      <td></td>
    </tr>
  </table>
</template>

<script>
import ContestGroupLink from './ContestGroupLink.vue';

export default {
  name: 'ContestGroupPreviewsTable',

  components: {
    ContestGroupLink
  },

  props: {
    contestId: {
      type: Number,
      required: true,
    },

    groups: {
      type: Array,
      required: true,
    },

    offset: {
      type: Number,
      default: 0,
    }
  },

  methods: {
    /** @param {number} groupId */
    createContestGroupId(groupId) {
      return {
        contestId: this.contestId,
        groupId: groupId,
      };
    },
  },
};
</script>

<style scoped>
.num {
  text-align: right;
}

.min-width {
  width: 1px;
}
</style>
